import React, { useState, useEffect } from 'react';
import NeonDivider from './NeonDivider';

const DailyFeatures = () => {
  const [currentDay, setCurrentDay] = useState(0);

  const dailySpecials = [
    {
      day: "MAGIC Monday",
      shortDay: "MON",
      special: "Your choice of any daily special",
      icon: "✨",
      color: "neonBlue",
      bgGradient: "from-blue-900/20 to-purple-900/20",
      buttonBg: "bg-neonBlue",
      buttonText: "text-black"
    },
    {
      day: "Tuesday WING NIGHT",
      shortDay: "TUE", 
      special: "Purchase a beverage and receive 1lb of wings for $15",
      icon: "🔥",
      color: "neonRed",
      bgGradient: "from-red-900/20 to-orange-900/20",
      buttonBg: "bg-neonRed",
      buttonText: "text-black"
    },
    {
      day: "Wednesday POUND & A HALF",
      shortDay: "WED",
      special: "Purchase a beverage and receive 1.5lbs of wings for $18",
      icon: "🍗",
      color: "yellow-400",
      bgGradient: "from-yellow-900/20 to-amber-900/20",
      buttonBg: "bg-yellow-300",
      buttonText: "text-black"
    },
    {
      day: "Thursday WING NIGHT",
      shortDay: "THU",
      special: "Purchase a beverage and receive 1lb of wings for $15", 
      icon: "🔥",
      color: "neonRed",
      bgGradient: "from-red-900/20 to-orange-900/20",
      buttonBg: "bg-neonRed",
      buttonText: "text-black"
    },
    {
      day: "TGIFriday",
      shortDay: "FRI",
      special: "Save $0.50 on domestic bottles",
      icon: "🍺",
      color: "green-400",
      bgGradient: "from-green-900/20 to-emerald-900/20",
      buttonBg: "bg-green-300",
      buttonText: "text-black"
    },
    {
      day: "Saturday RIB NIGHT",
      shortDay: "SAT",
      special: "Purchase a beverage and receive $3 off our Rib Combos",
      icon: "🥩",
      color: "neonRed",
      bgGradient: "from-red-900/20 to-pink-900/20",
      buttonBg: "bg-neonRed",
      buttonText: "text-black"
    },
    {
      day: "DRAUGHT Sunday",
      shortDay: "SUN",
      special: "Enjoy a pitcher of Budweiser, Bud Light or Labatt 50 and save $6 on 2lbs of wings",
      icon: "🍻",
      color: "neonBlue",
      bgGradient: "from-blue-900/20 to-indigo-900/20",
      buttonBg: "bg-neonBlue",
      buttonText: "text-black"
    }
  ];

  // Auto-rotate specials every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDay((prev) => (prev + 1) % dailySpecials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [dailySpecials.length]);

  // Set current day based on actual day of week
  useEffect(() => {
    const today = new Date().getDay(); // 0 = Sunday, 1 = Monday, etc.
    const dayMapping = [6, 0, 1, 2, 3, 4, 5]; // Map Sunday(0) to index 6, Monday(1) to index 0, etc.
    setCurrentDay(dayMapping[today]);
  }, []);

  const getCurrentSpecial = () => dailySpecials[currentDay];

  return (
    <section 
      id="daily-features" 
      className="py-12 sm:py-16 px-2 sm:px-4 relative
                 bg-black
                 sm:bg-gradient-to-br sm:from-gray-900 sm:via-black sm:to-gray-800
                 sm:before:content-[''] sm:before:absolute sm:before:inset-0 
                 sm:before:bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.02)_1px,transparent_1px)]
                 sm:before:bg-[length:40px_40px] sm:before:opacity-30"
    >
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-logoSans text-ivory mb-4">
            DAILY SPECIALS
          </h2>
          <p className="text-gray text-sm sm:text-base max-w-2xl mx-auto px-4">
            Every day brings something special at Billy's Wing Co. 
            Don't miss out on these legendary deals!
          </p>
        </div>

        <NeonDivider color="neonRed" />

        {/* Featured Special Display */}
        <div className="mb-8 sm:mb-12">
          <div className={`relative p-6 sm:p-8 rounded-2xl border border-gray/20 
                          bg-gradient-to-r ${getCurrentSpecial().bgGradient} 
                          hover:shadow-2xl transition-all duration-300 max-w-4xl mx-auto
                          backdrop-blur-sm`}>
            <div className="absolute inset-0 rounded-2xl bg-black/30"></div>
            <div className="relative z-10 text-center">
              <div className="flex items-center justify-center gap-3 mb-4">
                <span className="text-3xl sm:text-4xl">{getCurrentSpecial().icon}</span>
                <h3 className={`text-xl sm:text-2xl md:text-3xl font-logoSans text-${getCurrentSpecial().color}`}>
                  {getCurrentSpecial().day}
                </h3>
                <span className="text-3xl sm:text-4xl">{getCurrentSpecial().icon}</span>
              </div>
              <p className="text-ivory text-base sm:text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">
                {getCurrentSpecial().special}
              </p>
            </div>
          </div>
        </div>

        {/* Week Navigation */}
        <div className="grid grid-cols-7 gap-1 sm:gap-2 max-w-4xl mx-auto mb-8">
          {dailySpecials.map((special, index) => (
                         <button
               key={index}
               onClick={() => setCurrentDay(index)}
               className={`p-2 sm:p-3 rounded-lg border border-gray/20 transition-all duration-200 
                          hover:border-gray/40 text-center
                          ${currentDay === index 
                            ? `${special.buttonBg || 'bg-' + special.color} ${special.buttonText || 'text-black'} shadow-lg` 
                            : 'bg-black/30 text-gray hover:bg-black/50 hover:text-white'
                          }`}
             >
              <div className="text-lg sm:text-xl mb-1">{special.icon}</div>
              <div className="text-xs sm:text-sm font-medium">{special.shortDay}</div>
            </button>
          ))}
        </div>

        {/* All Specials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-8">
          {dailySpecials.map((special, index) => (
            <div
              key={index}
              className={`p-4 sm:p-6 border border-gray/10 rounded-xl 
                         bg-gradient-to-br ${special.bgGradient} backdrop-blur-sm
                         hover:shadow-lg transition-all duration-200 group cursor-pointer
                         ${currentDay === index ? 'ring-2 ring-' + special.color : ''}
                         `}
              onClick={() => setCurrentDay(index)}
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="text-2xl">{special.icon}</span>
                <h4 className={`font-logoSans text-lg sm:text-xl text-${special.color} group-hover:text-white transition-colors`}>
                  {special.day}
                </h4>
              </div>
              <p className="text-gray text-sm sm:text-base leading-relaxed group-hover:text-ivory transition-colors">
                {special.special}
              </p>
            </div>
          ))}
        </div>

        <NeonDivider color="neonBlue" />

        <div className="text-center mt-6 sm:mt-8 px-4">
          <p className="text-gray text-sm sm:text-base max-w-xl mx-auto">
            All specials are available all day on their respective days. 
            Some restrictions may apply. See server for details.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DailyFeatures; 